export default __webpack_public_path__ + "static/individuals-effected-by-fire-a46d2e3df2d3e2492ab8e5bd290e20e2.png";